angular.module('tradersyard').controller('analytic-account-ctrl', [
    '$scope',
    'graph-analytic-factory',
    function ($scope, $factory) {
        $scope.space = 'me';
        $scope.page = 0;
        $scope.process = false;
        $scope.accounts = [];

        $scope.init = function ($space) {
            if ($space) $scope.space = $space;

            $scope.find();
        };

        $scope.$entry = function ($space) {
            if ($space) $scope.space = $space;
        };

        $scope.find = function (next) {
            $scope.process = true;
            $factory
                .accounts($scope.space, {
                    page: ++$scope.page,
                })
                .then(function ($response) {
                    if ($response.data.state === 0 && $response.data.data.length > 0) {
                        $scope.accounts = $scope.accounts.concat($response.data.data);

                        if (next) next();
                    }

                    $scope.process = false;
                });
        };

        $scope.main = function ($account) {
            $scope.process = true;
            $factory.main($scope.space, $account.id).then(function ($response) {
                if ($response.data.state === 0) {
                    $scope.accounts.forEach(function (account) {
                        if (account.main === true) account.main = false;
                    });

                    $account.main = true;
                }

                $scope.process = false;
            });
        };
    },
]);
